import { openModal } from "action/modal/openModal";
import PAText, { FONT_SIZE } from "component/design-system/typography/PAText/PAText";
import { RootState } from "interfaces/generics.type";
import dynamic from "next/dynamic";
import { useDispatch, useSelector } from "react-redux";
import HideIf from "util/HideIf";
import { PAGE_TYPES } from "util/product/product-constants";
import { getSpinningImageIdx } from "../image-helper";
import ThumbnailImage from "./ThumbnailImage";
import styles from "./style.module.scss";

const ThumbnailVideo = dynamic(() => import(/* webpackChunkName: "breadcrum-all-products" */"./ThumbnailVideo"));

const maxThumbnails = 5;

function ThumbnailList(props: any) {
  const {
    thumbnails, dim, isPopUp,
    isDesktop,
    showSliderThum, imageTitle, isMobile,
    selectedImage, changeMainImage, spinningImage,
    getThumbImagePath, isWebpImage, productImages,
    productImagesV2, marketingImages, product, productLineVideos,
    videos,
  } = props;

  const { currentPageType } = useSelector((store: RootState) => store.utils);
  const dispatch = useDispatch();
  const updatedVideos = productLineVideos && productLineVideos.length > 0 ? productLineVideos : videos;

  const productThumbnails = Array.isArray(thumbnails) ? thumbnails.filter((el) => el.type === "image") : [];
  const productVideos = Array.isArray(updatedVideos) ? updatedVideos : [];
  const spinningImages = Array.isArray(spinningImage?.urls) ? spinningImage.urls : [];
  let productMedia = [...productThumbnails];

  if (spinningImages[0]) {
    const spinningImageEl = { type: "SPINNING_IMAGE", image: spinningImages[0] };
    const spinningImageIdx = getSpinningImageIdx(isDesktop, thumbnails.length, updatedVideos.length);
    productMedia = [...productThumbnails.slice(0, spinningImageIdx), spinningImageEl, ...productThumbnails.slice(spinningImageIdx)];
  }

  const verticalThumbnails = !isPopUp && isDesktop;
  const hideExtraThumbnails = verticalThumbnails && productMedia.length > maxThumbnails;

  const noProductThumbnailModal = !product && currentPageType !== PAGE_TYPES.PRODUCT_LINE_PAGE;

  const propsToPass = {
    lazyLoad: false,
    setSelectedImage: changeMainImage,
    selectedImage,
    imageTitle,
    dim,
    getThumbImagePath,
    aTagStyle: isMobile
      ? {
        width: dim.thumbnailContainer,
        height: dim.thumbnailContainer,
      }
      : {
        width: dim.thumbnailContainer,
        height: dim.thumbnailContainer,
      },
    imageProps: {
      maxWidth: dim.thumbnailImage,
      maxHeight: dim.thumbnailImage,
    },
  };

  const singleImageThumbnail = productMedia
    .slice(0, showSliderThum ? 4 : 5)
    .map((el: any, index: any) => (
      // eslint-disable-next-line react/jsx-key
      el.type === "SPINNING_IMAGE" ? (
        <ThumbnailImage
          key={index}
          {...propsToPass}
          image={getThumbImagePath(spinningImages[0], isWebpImage)}
          type="spinning"
          index={index}
          imgStyle={propsToPass.aTagStyle}
          className={styles.thumbnail_list}
          {...verticalThumbnails && { imageSize: 70 }}
        />
      )
        : (
          <ThumbnailImage
            key={index}
            {...propsToPass}
            {... {
              index, image: el.image,
            }}
            imgStyle={propsToPass.aTagStyle}
            className={styles.thumbnail_list}
            {...verticalThumbnails && { imageSize: 70 }}
          />
        )
    ));

  function handleThumbnailClick() {
    if (noProductThumbnailModal) {
      return;
    }
    dispatch(openModal("thumbnailVideo", {
      productImagesV2,
      productImages,
      getThumbImagePath,
      marketingImages,
      imageTitle,
      product,
      productLineVideos: updatedVideos,
      isImageClick: true,
      defaultSelectedImage: 0,
      isMobile,
    }));
  }

  return (
    <div
      className={`d-flex justify-content-center align-items-center ${styles.thumbnail_list}`}
      style={{ width: "100%" }}
    >
      {singleImageThumbnail}
      {/* <HideIf show={!hideExtraThumbnails}>
        {spinningImageThumbnail}
      </HideIf> */}

      <HideIf show={hideExtraThumbnails && !noProductThumbnailModal}>
        <div className={styles.extra_thumbnails} onClick={handleThumbnailClick}>
          <PAText fontSize={FONT_SIZE[3]}>
            {`${productMedia.length - maxThumbnails}+`}
          </PAText>
        </div>
      </HideIf>
      <HideIf show={productVideos.length}>
        <ThumbnailVideo {...{
          productLineVideos,
          productImages,
          productImagesV2,
          getThumbImagePath,
          marketingImages,
          imageTitle,
          product,
          videos,
        }}
        />
      </HideIf>
    </div>
  );
}

export default ThumbnailList;
